import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {useContextMenu} from "../../../hooks/ContextMenuHook.js";
import DynamicSvg from "../DynamicSvg.js";
import GlassContextMenu from "../GlassContextMenu.js";
import {ReactComponent as UpdateArrow} from '../../../images/icons/upArrow.svg'

export default function ModuleButton({ module, moduleControls }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({
        id: module.manifest.moduleId
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
        zIndex: isDragging ? 1000 : "auto",
    };

    const { openMenu, closeMenu, isMenuOpen, getMenuPosition } = useContextMenu();
    const menuId = `module-${module.manifest.moduleId}`;

    const handleContextMenu = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isMenuOpen(menuId)) {
            closeMenu(menuId);
            return;
        }

        openMenu(menuId, {
            mouseX: e.clientX + 2,
            mouseY: e.clientY - 6,
        });
    };

    const iconPath = module.manifest.moduleIconPath ?? "/media/images/icons/module-logo-placeholder.svg";
    const isSvg = iconPath.endsWith('svg');

    const menuItems = [
        {
            label: 'Uninstall',
            action: 'uninstall',
            onClick: () => moduleControls.uninstallModule(module.manifest.moduleId)
        },
        {
            label: 'Load',
            action: 'load',
            onClick: () => moduleControls.loadModule(module.manifest.moduleId)
        },
        {
            label: 'Unload',
            action: 'unload',
            onClick: () => moduleControls.unloadModule(module.manifest.moduleId)
        }
    ];

    if(module.status === "ERRORED") menuItems.unshift({
        label: 'Module load error!',
        notification: true,
        className: 'errored-notice'
    })

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            data-module-id={module.manifest.moduleId}
        >
            <div
                id={menuId}
                className={"module-button" + (module.status === "ERRORED" ? " errored" : "")}
                onContextMenu={handleContextMenu}
                style={{
                    pointerEvents: isDragging ? 'none' : 'auto',
                    cursor: isDragging ? 'grabbing' : 'grab'
                }}
            >
                {
                    isSvg ? (
                            <>
                                <DynamicSvg className="content-layer" src={iconPath} />
                                <DynamicSvg className="embed-layer" src={iconPath} />
                                <DynamicSvg className="embed-layer2" src={iconPath} />
                                <DynamicSvg className="glow-layer" src={iconPath} />
                            </>
                        )
                        : ( <img src={iconPath} alt="module-icon" style={{ pointerEvents: 'none' }} /> )
                }

                {
                    module.updateAvailable && (
                        <div
                            className="module-update-notifier"
                            id={`button-update-${module.manifest.moduleId}`}
                            data-latest-version={module.updateAvailable}
                            style={{ pointerEvents: 'auto' }}
                            onPointerDown={(e) => e.stopPropagation()}
                            onContextMenu={(e) => e.stopPropagation()}
                        >
                            <div className="update-pip"></div>
                            <UpdateArrow className="update-arrow"></UpdateArrow>
                        </div>
                    )
                }

                <GlassContextMenu
                    key={menuId}
                    title={module.manifest.moduleName || module.manifest.moduleId}
                    items={menuItems}
                    contextMenu={isMenuOpen(menuId) ? getMenuPosition(menuId) : null}
                    onClose={() => closeMenu(menuId)}
                />
            </div>
        </div>
    );
}